export enum IOrderFilter {
  Unfulfilled,
  Fulfilled,
  AM,
  PM,
  RescheduledStandingOrders,
  Urgent,
}
